import React from 'react';
import './header.scss';
import company from '@visit/images/logowhite.png'

function Header() {

  const goHomePage = () => {
    window.location.href = 'https://www.001pt.com/';
  }

  const goGuide = () => {
    window.location.href = 'https://www.001pt.com/guide';
  }

  return (
    <header className="header">
        <div className="header-left">
            <img src="https://pic.001pt.com/logo/logo_visit.png"/>
        </div>
        <div className="header-right">
            <div className="nav-item" onClick={goHomePage}>首页</div>
            <div className="nav-item" onClick={goGuide}>使用指南</div>
        </div>
    </header>
  );
}

export default Header;
